import { render, staticRenderFns } from "./CategoryStyle.vue?vue&type=template&id=a58d9f6a&scoped=true&"
import script from "./CategoryStyle.vue?vue&type=script&lang=js&"
export * from "./CategoryStyle.vue?vue&type=script&lang=js&"
import style0 from "./CategoryStyle.vue?vue&type=style&index=0&id=a58d9f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58d9f6a",
  null
  
)

export default component.exports